<template>
  <v-container>
      
      <v-row class="mt-3" justify="center">
        <v-col cols="11">
            <v-card class="mx-auto">
                <v-card-title style="color:#48c074">
                  All Users
                </v-card-title>
                <v-data-table
                    :headers="transHeaders"
                    :items="Users"
                    no-data-text='No Users Available'
                    >
                    <template v-slot:item.status="{ item }">
                        <span class="black--text">{{item.status}}</span>
                    </template>
                    <template v-slot:item.desc="{ item }">
                        <span class="black--text">{{item.description}}</span>
                    </template>
                    <template v-slot:item.type="{ item }">
                        <span class="black--text">{{item.paymentType}}</span>
                    </template>
                    <template v-slot:item.date="{ item }">
                        <span class="black--text">{{item.datePerformed}}</span>
                    </template>
                    <template v-slot:item.amount="{ item }">
                        
                        <span class="black--text">&#8358;{{item.amount}}</span>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-btn text  @click="viewUser(item._id)" style="border: 1px #48c074 solid; color:#48c074" class="text-none" small>View</v-btn>
                    </template>
                </v-data-table>
            </v-card>
        </v-col>
      </v-row>
                
  </v-container>
</template>

<script>
export default {
  data(){
    return{
      transHeaders: [
        {
            text: 'FirstName',
            align: 'start',
            sortable: false,
            value: 'firstname',
        },
        { text: 'LastName', value: 'lastname' },
        { text: 'Email', value: 'email' },
        { text: 'Date Added', value: 'date_created' },
        { text: '', value: 'action' },
        
                
                
      ],
    }
  },
  computed:{
        Users(){
            let user = this.$store.state.users.users
            for(let i=0; i<user.length; i++){
              user[i].date_created = user[i].date_created.slice(0, 19).replace('T', ' ')
            }
            return user
        },
  },
    methods: {
      viewUser(id){
        this.$store.dispatch("GetUsersById", id)
            .then(()=>{
                this.$router.push('/manageusers/'+id)
            })
            .catch(()=>{
          })
      }
    },
  created(){
     this.$store.dispatch("GetUsers")
      .then(()=>{ 
      })
      .catch(()=>{
      });
  }
}
</script>

<style>

</style>